import { useState, useEffect } from "react"
import Toast from 'react-bootstrap/Toast';
import ToastContainer from 'react-bootstrap/ToastContainer';
import CboGrupo from "./CboGrupo";
import CboEmpresa from "./CboEmpresa";

const Secciones = (props) => {


  const [codigo, setCodigo] = useState("")
  const [nombre, setNombre] = useState("")
  const [grupo, setGrupo] = useState("")
  const [empresa, setEmpresa] = useState("")
  const [secciones, setSecciones] = useState([])



  const [activo, setActivo] = useState(false)
  const [noteditable, setNotEditable] = useState(true)

  // ventana de búsqueda
  const [vermodal, setVermodal] = useState(false)


  // ventana de confirmación
  const [vermodalconf, setVermodalConf] = useState(false)

  // toast
  const [showToast, setShowToast] = useState(false);
  const [textoToast, setTextoToast] = useState("");

  /*
     async function    handleOnChangeActivo(e){
      setSearchActivo(!searchactivo); 
      setSearchMessage("");
   }
   
  */



  useEffect(() => {

    var json3;
    var jsons3;
    var url3;
    let consulta = new Object();

    setGrupo(props.grupo);
    consulta.grupo = props.grupo;
    consulta.empresa = 1;

    jsons3 = JSON.stringify(consulta);


    var options3 = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'

      },
      mode: 'cors',
      credential: 'include',
      body: jsons3,

    };

    url3 = `${process.env.REACT_APP_API_URL}/sec/allsecciones`;



    fetch(url3, options3)
      .then(response => response.json())
      .then(data => {

        json3 = data.data;
        setSecciones(json3);
        // si hay datos, cargar en la ficha el primero
        if (json3.length) {

          setNombre(json3[0].Sec_Nombre);
        }
        console.log("Secciones", json3);

      })


  }, []);




  const handleGoSeccion = (index, event) => {
    setNombre(secciones[index].Sec_Nombre);

  }


  const handleGrupoChange = (event) => {
    setGrupo(event.target.value);
  };

  const handleEmpresaChange = (event) => {
    setEmpresa(event.target.value);
  };


  /* Save */
  async function handleSave(e) {
    // validar ???

    // llamo a la grabación del registro de alumno

    let unAlumno = new Object();
    unAlumno.codigo = codigo;
    unAlumno.nombre = nombre;

    //        addAlumno(unAlumno);

    var url;
    var json;
    e.preventDefault()
    try {
      setNotEditable(true);
      json = JSON.stringify(unAlumno);
      console.log(json);
      if (codigo) {
        url = `${process.env.REACT_APP_API_URL}/alu/update`;
      }
      else {
        url = `${process.env.REACT_APP_API_URL}/alu/addnew`;
      }


      var options = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        mode: 'cors',
        credential: 'include',
        body: json,

      };

      fetch(url, options)
        .then(response => response.json())
        .then(data => {

          json = data.data;
          console.log(json);
          // setNombre (json.nombre);
          // setApellido (json.apellido);            
          // setActivo (json.actvo);

          /* toast */
          setTextoToast("Alumno guardado");
          setShowToast(true);


        })
    } catch (error) {
      console.log(error);

    }



  }

  async function handleNew(e) {
    setCodigo("");
    setNombre("");

    setNotEditable(false);
  }


  async function handleCancel(e) {
    setCodigo("");
    setNombre("");

    setNotEditable(true);

  }

  /* Editar */
  async function handleEdit(e) {
    e.preventDefault()
    try {

      setNotEditable(false);
    } catch (error) {
      console.log(error);

    }

  }




  return (
    <div >




      <div className="container-fluid">
        <h3>Secciones</h3>
        <div className="row">


          <div className="col-xs-12 col-lg-10 col-sm-10 col-md-10">
            <form>
              <div className="row align-items-end">

                <CboGrupo
                  selectedValue={grupo}
                  onChange={handleGrupoChange}
                  disabled={true}
                  grusu={props.grusu}
                />


                <CboEmpresa
                  selectedValue={empresa}
                  onChange={handleEmpresaChange}
                  disabled={true}
                  grupo={props.grupo}
                  grusu={props.grusu}
                />

                <div className="col-lg-2 col-sm-6">
                  <div className="form-group">

                    <label className="l">
                      Nombre
                    </label>

                    <input
                      type="text"
                      className="input-select"
                      placeholder="Nombre"
                      onChange={e => setNombre(e.target.value)}
                      value={nombre}
                      disabled={noteditable}
                    />

                  </div>

                </div>
                <div className="col-lg-1 col-sm-4">

                  <div className="form-group">

                    <label className="l d-block">
                      Activo
                    </label>

                    <input
                      type="checkbox"
                      checked={activo}
                      disabled={true}
                    />

                  </div>

                </div>

              </div>

            </form>



            <div className=" acciones-liquidacion">

              <div className="col  col-1 text-center border-info">
                <button type="button" className="filtrar" id="clear" onClick={handleNew} disabled={!noteditable} >Nuevo</button>
              </div>

              <div className="col  col-1 text-center border-info">
                <button type="button" className="filtrar" id="edit" onClick={handleEdit} disabled={!codigo}>Editar</button>
              </div>
              <div className="col  col-1 text-center border-info">
                <button type="button" className="filtrar" id="remove" disabled={!noteditable}>{activo ? 'Desactivar' : 'Reactivar'}</button>
              </div>

              <div className="col  col-1 text-center border-info">
                <button type="button" className="filtrar" id="grabar" onClick={handleSave} disabled={noteditable}>Guardar</button>
              </div>
              <div className="col  col-1 text-center border-info">
                <button type="button" className="filtrar" id="cancelar" onClick={handleCancel} disabled={noteditable}>Cancelar</button>
              </div>


            </div>
          </div>

        </div>


        <table className="table table-striped table-primary table-hover m-3 p-2">
          <thead>
            <tr className="row" >
              <th className="col-1" >Sección</th>
            </tr>
          </thead>
          <tbody>
            {


              secciones.map((unolista, index) => (
                <tr key={index + '_row'} className="row" onClick={(event) => handleGoSeccion(index, event)}>
                  <td key={index + '_ident'} className="col-1" >
                    {unolista.Sec_Nombre}
                  </td>

                </tr>
              )
              )
            }

          </tbody>
        </table>

      </div>

      <ToastContainer position="bottom-end">
        <Toast onClose={() => setShowToast(false)} show={showToast} delay={3000} autohide>

          <Toast.Body>{textoToast}</Toast.Body>
        </Toast>
      </ToastContainer>










      <div className="toast-container position-fixed bottom-0 end-0 p-3">
        <div id="liveToastmsg" className="toast" role="alert" aria-live="assertive" aria-atomic="true">

          <div className="toast-body">

          </div>
        </div>
      </div>













    </div>
  );
};

export default Secciones;

